// extracted by mini-css-extract-plugin
export default {"link":"addWidget_link__z9zZP"};